// extracted by mini-css-extract-plugin
module.exports = {"block":"PlayerBio_block__VDs5E","edit":"PlayerBio_edit__VOaBl","bio":"PlayerBio_bio__ytYAq","clamp":"PlayerBio_clamp__AZVDW"};